// 获取屏幕宽度并计算比例
export const getFontSize = (res) => {
  let systemRatio = window.devicePixelRatio
  let size = 100 / systemRatio / 100
  let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  if (!clientWidth) return
  let clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
  let fontSize = 0
  let wSize = 100 * (clientWidth / 1920)
  let hSize = 100 * (clientHeight / 1080)
  fontSize = hSize
  if (wSize > hSize) {
    fontSize = wSize
  }

  return (res * fontSize) / size
}
